const toolTipManager = {
    toolTip: undefined,
    localPosition: 0,
    changeHoverState: undefined,

    init() {
        var holder = document.getElementById('toolTipHolder');
        this.toolTip = document.createElement('div');
        holder.addEventListener('mouseover', this.onMouseOver.bind(this));
        holder.addEventListener('mouseout', this.onMouseOut.bind(this));

        this.toolTip.style.position = 'absolute';
        this.toolTip.style.fontSize = 11 + 'px';
        this.toolTip.style.background = 'white';
        this.toolTip.style.height = 40 + 'px';
        this.toolTip.style.wordWrap = 'break-word';
        this.toolTip.style.textAlign = 'center';
        this.toolTip.style.paddingTop = 2 + 'px';
        this.toolTip.style.paddingLeft = 5 + 'px';
        this.toolTip.style.paddingRight = 5 + 'px';
        this.toolTip.style.borderLeftStyle = 'solid';
        this.toolTip.style.borderBottomStyle = 'solid';
        this.toolTip.style.borderRightStyle = 'solid';
        this.toolTip.style.borderColor = '#c05600';
        this.toolTip.style.borderWidth = '1px';
        this.toolTip.style.cursor = '-webkit-grab';
        this.toolTip.style.zIndex = 999999;

        holder.appendChild(this.toolTip);
    },
    showToolTip(text, target, type, changeHoverState) {
        if (this.toolTip == undefined)
            this.init();

        this.changeHoverState = changeHoverState;
        const bounds = target.getBoundingClientRect();

        this.toolTip.style.display = 'block';
        this.toolTip.innerHTML = text;
        this.toolTip.style.left = (bounds.left - this.localPosition) + 'px';
        this.toolTip.style.width = (bounds.width - 2 * 6) + 'px';
        this.toolTip.style.pointerEvents = 'none';

        if (type == 'ListItemRendererBackground')
            this.toolTip.style.top = (bounds.top + 66) + 'px';
        else
            this.toolTip.style.top = (bounds.top + 78) + 'px';
    },
    hideToolTip() {
        if (this.toolTip)
            this.toolTip.style.display = 'none';
    },
    onMouseOver() {
        if (this.changeHoverState)
            this.changeHoverState(true);

        if (this.toolTip)
            this.toolTip.style.display = 'block';
    },
    onMouseOut() {
        if (this.changeHoverState)
            this.changeHoverState(false);

        this.hideToolTip();
    },
    resetToolTip() {
        this.toolTip = undefined;
    }
};

export default toolTipManager;



/** WEBPACK FOOTER **
 ** ./src/components/utils/ToolTipManager.js
 **/